// extracted by mini-css-extract-plugin
export default {"container":"sidebar_container__ohKfD","left":"sidebar_left__6CrEF","right":"sidebar_right__ivBWO"};